import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, MapPin, Users, Clock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import heroImage from "@/assets/hero-image.jpg";

const Hero = () => {
  const navigate = useNavigate();
  return (
    <section className="pt-24 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-background to-secondary/20">
      <div className="container mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <Badge variant="secondary" className="text-sm font-medium">
                <MapPin className="w-4 h-4 mr-2" />
                Serving Minnesota
              </Badge>
              
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
                Streamline Care
                <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                  {" "}Placement
                </span>
                <br />
                in Minnesota
              </h1>
              
                <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed max-w-2xl">
                  Connect Minnesota's assisted living, long-term care, and HSS service providers 
                  with placement professionals including case managers, discharge planners, 
                  social workers, and housing stabilization service workers.
                </p>
            </div>

            <div className="grid sm:grid-cols-3 gap-6">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Users className="w-5 h-5 text-primary" />
                </div>
                 <div>
                   <div className="font-semibold text-sm">3 Flexible</div>
                   <div className="text-xs text-muted-foreground">Subscription Tiers</div>
                 </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
                  <Clock className="w-5 h-5 text-accent" />
                </div>
                <div>
                  <div className="font-semibold text-sm">Real-time</div>
                  <div className="text-xs text-muted-foreground">Availability updates</div>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
                  <ArrowRight className="w-5 h-5 text-success" />
                </div>
                <div>
                  <div className="font-semibold text-sm">Faster</div>
                  <div className="text-xs text-muted-foreground">Placement process</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg" 
                className="bg-gradient-to-r from-primary to-primary-glow hover:shadow-lg hover:scale-105 transition-all duration-200"
                onClick={() => navigate('/login')}
              >
                Sign Up Now
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </div>

            <div className="flex items-center space-x-6 text-sm text-muted-foreground">
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-success rounded-full"></div>
                <span>Referral submission made easy</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-success rounded-full"></div>
                <span>24/7 Support</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-success rounded-full"></div>
                <span>No Setup Fees</span>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-accent/20 rounded-2xl blur-3xl"></div>
            <img
              src={heroImage}
              alt="Healthcare professionals using CareKonnect platform"
              className="relative rounded-2xl shadow-2xl w-full h-auto"
              style={{ boxShadow: 'var(--shadow-elegant)' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;